/* =========================
   WrapUp2025.tsx
   ========================= */
import React, { useState } from 'react';
import './WrapUp2025.css';

const WRAPUP_TEXT = `Подходит к завершению очередной учебный год для наших воспитанников.

Несмотря на это, занятия в Шахматной школе Анатолия Николаевича Терехина продолжатся и в июне — для тех, кто стремится и дальше совершенствовать свое мастерство, развиваться и добиваться новых побед за шахматной доской.

Этот учебный год стал для нашей школы насыщенным и результативным. Наши ученики приняли участие во множестве турниров различного уровня, и большинство выступлений оказались успешными.
За год воспитанниками школы было завоевано 82 медали различного достоинства — золотые, серебряные и бронзовые — на всероссийских, краевых, городских и школьных соревнованиях.

Эти достижения являются результатом большого труда самих ребят, поддержки родителей и профессиональной работы тренерского состава школы.

Особо хочется отметить наших воспитанников:
Путин Георгий, Чудик Сергей, Колотыгин Марк, Ефремов Марк, Аширов Александр, Корбут Иван, Корбут Гордей, Хатипова Яна, Масленников Яромир, Горбацевич Михаил, Миночкина Алена, Горюнова Анна, Гусев Савелий, Гиренко Марк, Зырянов Михаил, Тупицин Григорий, Мырзина Варвара, Возиян Михаил, Зеленин Родион, Владимирова Мария, Доронина Полина, Юрков Лев.

Также благодарим наших бывших учеников, чьи результаты и достижения были внесены в общий зачет школы до ноября 2025 года:
Иванова Екатерина, Белобородова Маргарита, Гладких Злата, Чистякова Анастасия и Чистякова Анна.

Выражаем искреннюю благодарность нашим ученикам и их родителям за доверие, старание, трудолюбие и любовь к шахматам.

Желаем всем хорошего отдыха, новых сил и дальнейших успехов!`;

export default function WrapUp2025() {
  const [open, setOpen] = useState(false);

  return (
    <div className="wrapup">
      <button
        className="wrapup__header wrapup__header_button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="wrapup-content"
      >
        <span className="wrapup__title">Итоги учебного года 2025–2026</span>
        <span className="wrapup__icon">{open ? '−' : '+'}</span>
      </button>

      <div
        id="wrapup-content"
        className={`wrapup__content ${open ? 'wrapup__content--open' : ''}`}
      >
        <pre className="wrapup__text">{WRAPUP_TEXT}</pre>
      </div>
    </div>
  );
}
